import { useEffect, useRef, useState } from 'react'

import {
    FaClipboardCheck,
    FaRegCopy,
} from 'react-icons/fa'

import SmallButton from './SmallButton'

const CopyButton = ({
    value
}) => {
    const [copied, setCopied] = useState(false)
    const copiedReset = useRef(null)

    useEffect(() => {
        if (copied) {
            if (copiedReset.current) {
                clearInterval(copiedReset.current)
            }

            copiedReset.current = setTimeout(() => {
                setCopied(false)
            }, 1500)
        }
    }, [copied])

    return <SmallButton
        onClick={event => {
            navigator.clipboard.writeText(value)
            setCopied(true)
        }}
    >
        {copied
            ? <FaClipboardCheck color="green" />
            : <FaRegCopy />}
    </SmallButton>
}

export default CopyButton